export default __webpack_public_path__ + "static/media/img (4).3c86c306.jpg";